module.exports = "<fan-proyecto-documentos-plantillas-lista\r\n    kd-await=\"$ctrl.promise\"\r\n    data=\"$ctrl.data\"></fan-proyecto-documentos-plantillas-lista>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fan/proyecto/components/documentos/plantillas/template.html
// module id = 500
// module chunks = 0